import { render } from "./Navbar.vue?vue&type=template&id=273d1a4b&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=273d1a4b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-273d1a4b"

export default script